import { Roles } from '@/utils/roles';
import { FeaturesEnum } from '@utils/features';
import { ProductListPage } from '../elements';
import { pathJoin } from '../paths';
import { resolvePathRoute } from '../generate-route';

const ROOT = 'products';
export const paths = (root: string): any => ({
  root: {
    path: pathJoin(root, [ROOT]),
    title: ROOT,
    icon: 'system-uicons:boxes',
    guard: [Roles.ADMIN],
    custom: true,
    onlyOption: true,
    feature: FeaturesEnum.PRODUCTS,
  },
  list: {
    path: pathJoin(root, [ROOT, 'list']),
    element: ProductListPage,
    params: undefined,
    title: 'list',
    show: true,
    guard: [Roles.ADMIN],
    feature: FeaturesEnum.PRODUCTS_LIST,
  },
});

export const pathProducts = (root: string) => ({
  [ROOT]: resolvePathRoute(paths(root)),
});
